import React, { useState, useEffect } from 'react';
import '../styles/BackToTop.css';

const BackToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        
        // Si estamos en la página de Lore, resetear el evento activo a 0
        if (window.location.pathname === '/lore') {
            // Buscar el componente Lore y resetear su activeEvent
            const loreComponent = document.querySelector('.lore-page');
            if (loreComponent) {
                // Disparar un evento personalizado para resetear el activeEvent
                const resetEvent = new CustomEvent('resetActiveEvent', { detail: { index: 0 } });
                window.dispatchEvent(resetEvent);
            }
        }
    };

    return (
        <a 
            href="#" 
            className={`back-to-top ${isVisible ? 'visible' : ''}`}
            onClick={scrollToTop}
            aria-label="Volver arriba"
        >
            <i className="fas fa-chevron-up"></i>
        </a>
    );
};

export default BackToTop; 